import type { CareStateDomainDb } from '@/entities/care-state-domain';

export function getOpenRequestsCount(careState: CareStateDomainDb | null): number {
  if (careState === null) {
    return 0;
  }

  return careState.requests.reduce((count, request) => {
    if (request.status === 'Open') {
      return count + 1;
    }
    return count;
  }, 0);
}
